"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElevenLabsTimeoutError = exports.ElevenLabsError = void 0;
var ElevenLabsError_1 = require("./ElevenLabsError");
Object.defineProperty(exports, "ElevenLabsError", { enumerable: true, get: function () { return ElevenLabsError_1.ElevenLabsError; } });
var ElevenLabsTimeoutError_1 = require("./ElevenLabsTimeoutError");
Object.defineProperty(exports, "ElevenLabsTimeoutError", { enumerable: true, get: function () { return ElevenLabsTimeoutError_1.ElevenLabsTimeoutError; } });
